// This file is automatically generated. DO NOT EDIT.

import { type LegacyChoiceResult } from '../../../../types/response/LegacyChoiceResult';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetChoiceResultsResponse {
  /** The results */
  results: Array<LegacyChoiceResult>;
}

export async function getChoiceResultsResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetChoiceResultsResponse>,
): Promise<GetChoiceResultsResponse> {
  return getJSONResponse<GetChoiceResultsResponse>(
    response,
    'getChoiceResultsResponse',
    options,
  );
}
